import { Arrow } from './Arrow/Arrow';
import { Bell } from './Bell/Bell';

export const Icons = {
  Arrow,
  Bell,
};
